(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabFileTypes', TabFileTypes);

    TabFileTypes.$inject = ['$resource'];

    function TabFileTypes ($resource) {
        var resourceUrl =  'api/tab-file-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
